import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _ctx.filteredTableData,
      stripe: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "lastEstimation",
          label: _ctx.$t('label.lastEstimation'),
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.lastEstimation), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "nextEstimation",
          label: _ctx.$t('label.nextEstimation'),
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.nextEstimation), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "reason",
          label: _ctx.$t('label.reason'),
          align: "center",
          filters: [
        { text: 'STOP_STATION', value: 'STOP_STATION' },
        { text: 'UNKNOWN_STATUS', value: 'UNKNOWN_STATUS' },
      ],
          "filter-method": _ctx.filterReason,
          "filter-placement": "bottom-end"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: row.reason === 'STOP_STATION' ? 'danger' : 'warning'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.reason), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }, 8, ["label", "filter-method"]),
        _createVNode(_component_el_table_column, { align: "center" }, {
          header: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.startDatePicker,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDatePicker) = $event)),
              type: "datetime",
              format: _ctx.$t('format.dateTime'),
              placeholder: _ctx.$t('label.fromDate'),
              style: {"margin-right":"5px"},
              onChange: _ctx.onDateChange,
              "disabled-date": _ctx.disabledDate
            }, null, 8, ["modelValue", "format", "placeholder", "onChange", "disabled-date"]),
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.endDatePicker,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDatePicker) = $event)),
              type: "datetime",
              format: _ctx.$t('format.dateTime'),
              placeholder: _ctx.$t('label.endDate'),
              onChange: _ctx.onDateChange,
              "disabled-date": _ctx.disabledFutureDate
            }, null, 8, ["modelValue", "format", "placeholder", "onChange", "disabled-date"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      class: "app-table",
      layout: "total, sizes, prev, pager, next, jumper",
      currentPage: _ctx.currentPage,
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event)),
      "page-sizes": [10, 20, 50, 100],
      "page-size": _ctx.rowPerPage,
      total: _ctx.filteredTableData.length,
      onSizeChange: _ctx.changePaginationSize,
      onCurrentChange: _ctx.changePaginationPage
    }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
  ], 64))
}